import { observable, action, computed, autorun, runInAction } from 'mobx'
import $http from '@/utils/http'
import { storage } from '@/utils/tools'
import { AUTH_TOKEN } from '@/constants'

export class LoginStore {
  @observable username = ''
  @observable password = ''
  @observable loading = false
  
  @action inputChange = (value: string, type: string): void => {
    if(type === 'pwd') {
      this.password = value
    } else {
      this.username = value.trim()
    }
  }

  @computed get canLogin () {
    return this.password.length > 5 && this.username.length > 2
  }

  @action login = () => {
    if(this.loading) {
      return
    }
    if(!this.canLogin) {
      // $msg.error('请输入正确格式的用户名和密码')
      return
    }
    this.loading = true
    $http.post('/cms/user/login', {
      username: this.username,
      password: this.password
    }).then((res: any) => {
      storage.set(AUTH_TOKEN, res.token) // store jwt token
      location.href = '/admin'
      runInAction(() => {
        this.loading = false
      })
    }, err => {
      runInAction(() => {
        this.loading = false
      })
    })
  }

}

export default new LoginStore()